import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProjectionInput } from '../models/ProjectionInput';

@Injectable({
  providedIn: 'root'
})
export class CalculatorService {

  constructor(private httpClient: HttpClient) { }

  public calculate(input: ProjectionInput): Observable<any>{
    return this.httpClient.post<string>(`${environment.apiBaseUrlPrefix}/Projection`, input);
  }

}
